import { render, staticRenderFns } from "./otherContractHistoryDetail.vue?vue&type=template&id=e17f2d44"
import script from "./otherContractHistoryDetail.vue?vue&type=script&lang=js"
export * from "./otherContractHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports